export default "__VITE_ASSET__fOT7Q$tq__"